module.exports = "<rm-rules-panel></rm-rules-panel>";